// icon 按需在 main 中通过 ensureIconsLoaded 加载

// Initialize stores and migrate legacy data
import { useAuthStore } from '@/stores/auth-store'
import { usePermissionStore } from '@/stores/permission-store'

export function initStores() {
  const authStore = useAuthStore()
  const permissionStore = usePermissionStore()

  // Migrate legacy data from old storage locations
  authStore.migrateLegacyData()
  permissionStore.migrateLegacyData()
}
